module.exports = __webpack_public_path__ + "img/banner_4.6dd99bf5.jpg";